import { createBrowserHistory, createMemoryHistory } from 'history';

import { isWindow } from 'common/helpers/helpers';

// This is required for multiple routers use the same shared history object
const history = isWindow ? createBrowserHistory() : createMemoryHistory();

export default history;
